import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

//actions:
import { navigate } from '../../actions';

//components:
import CentroDia from '../centro_dia';
import CierreSemanalLecturasArcade from '../acc_cierre_semanal/cierre_semanal_lect_arcade';

//material ui:
import { withStyles } from '@material-ui/core/styles';

import * as config from '../../constants/configuration';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    toolbar: {
        display: 'block',
        minHeight: '112px'
    },
});

class EntLecturaMaqArcade extends Component {

    componentDidMount() {

        if (!this.props.user && config.AUTH) {
            this.props.navigate(""); //go to home page
            return;
        }


    };

    renderGastos = () => {
        if (this.props.centroDiaSelected.centro.id !== undefined && this.props.centroDiaSelected.dia !== '') {
            return (<CierreSemanalLecturasArcade fecha={this.props.centroDiaSelected.dia}/>);
        }
    }

    render() {

        const { classes } = this.props;


        return (
            <div className={classes.root}>
                <div className={classes.toolbar} />
                <CentroDia semanal />

                {this.renderGastos()}
            </div>
        );

    };

};

EntLecturaMaqArcade.propTypes = {
    //state
    centroDiaSelected: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    //dispatch
    navigate: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        centroDiaSelected: state.centroDiaSelected
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        navigate,
    }, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(EntLecturaMaqArcade));